package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.{className, div}

@react object AlignedLineLeft {
	case class Props
	(
		children: ReactElement*
	)

	val component = FunctionalComponent[Props] { props =>
		div(
			className := "nfw-align-container-left"
		)(
			props.children:_*
		)
	}
}

@react object AlignedLineCenter {
	case class Props
	(
		children: ReactElement*
	)

	val component = FunctionalComponent[Props] { props =>
		div(
			className := "nfw-align-container-center"
		)(
			props.children:_*
		)
	}
}

@react object AlignedLineRight {
	case class Props
	(
		children: ReactElement*
	)

	val component = FunctionalComponent[Props] { props =>
		div(
			className := "nfw-align-container-right"
		)(
			props.children:_*
		)
	}
}

@react object AlignedLine {
	case class Props
	(
		children: ReactElement*
	)

	val component = FunctionalComponent[Props] { props =>
		div(
			className := "nfw-align-container"
		)(
			props.children:_*
		)
	}
}
